import { Component, Input } from '@angular/core';

@Component({
  selector: 'hospital-assigned',
  standalone: false,
  templateUrl: './hospital-assigned.component.html',
  styleUrl: './hospital-assigned.component.scss'
})
export class HospitalAssignedComponent {

}
